import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../functions/Auth';
import { useLocation } from 'react-router-dom';


// component
import GlobalNavigarion from '../components/GlobalNavigation';
import { hasUnreadNotifications } from '../api/notifications';

// mui
 import { useMediaQuery, useTheme } from "@mui/material";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Badge from '@mui/material/Badge';

// icons
import MenuIcon from '@mui/icons-material/Menu';
//import AccountCircle from '@mui/icons-material/AccountCircle';
import NotificationsIcon from '@mui/icons-material/Notifications';

const drawerWidth = 280;

export default function PrimarySearchAppBar() {
    const theme = useTheme();
    const matches: boolean = useMediaQuery(theme.breakpoints.up("pc"));
    const userInfo = useContext(UserContext);
    const userId = userInfo?.userId;
    const navigate = useNavigate();
    const location = useLocation();
    const pathname = location.pathname

    const [invisible, setInvisible] = React.useState(true);

    const fnCheckNotifications = async (userId: number) => {
        const response = await hasUnreadNotifications(userId);
        if (response) {
            setInvisible(!response);
        } else {
            setInvisible(true);
        }
    }

    useEffect(() => {
        if (userId) {
            fnCheckNotifications(userId);

            const interval = setInterval(() => {
                fnCheckNotifications(userId);
            }, 300000);
            return () => clearInterval(interval);
        }
    }, [userId]);

    useEffect(() => {
        if (userId) {
            fnCheckNotifications(userId);
        }
    }, [userId, pathname])

    // Drawer
    const [isGlobalMenuOpen, setIsGlobalMenuOpen] = React.useState(false);
    const toggleDrawer = () => setIsGlobalMenuOpen(!isGlobalMenuOpen);

    return (
        <Box>
            <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <Toolbar>
                    {!matches &&
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="open drawer"
                            sx={{ mr: 2 }}
                            onClick={toggleDrawer}
                        >
                            <MenuIcon />
                        </IconButton>
                    }
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                    >
                        CONNECT
                    </Typography>
                    <Box sx={{ flexGrow: 1 }} />
                    <Box sx={{ display: "flex" }}>
                        <IconButton
                            size="large"
                            aria-label="show new notifications"
                            color="inherit"
                            onClick={() => navigate("/notifications")}
                        >
                            <Badge
                                color="error"
                                variant="dot"
                                invisible={invisible} 
                            >
                                <NotificationsIcon />
                            </Badge>
                        </IconButton>
                    {/*    <IconButton*/}
                    {/*        size="large"*/}
                    {/*        edge="end"*/}
                    {/*        aria-label="account of current user"*/}
                    {/*        aria-haspopup="true"*/}
                    {/*        onClick={() => navigate("/account")}*/}
                    {/*        color="inherit"*/}
                    {/*    >*/}
                    {/*        <AccountCircle />*/}
                    {/*    </IconButton>*/}
                    </Box>
                </Toolbar>
            </AppBar>
            <Drawer
                anchor={'left'}
                open={isGlobalMenuOpen}
                onClose={toggleDrawer}
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
                }}
            >
                <Toolbar />
                <GlobalNavigarion />
            </Drawer>
        </Box>
    );
}